import React from 'react';

const PrivacyPolicy = () => {
  return (
    <div style={{ maxWidth: '800px', margin: '0 auto', padding: '20px', fontFamily: 'Arial, sans-serif' }}>
      <h1 style={{ textAlign: 'center' }}>Privacy Policy for UrPoster</h1>
      <p><strong>Last Updated: April 15, 2025</strong></p>

      <p>At UrPoster ("we," "us," or "our"), we value your privacy and are committed to protecting your personal information. This Privacy Policy explains how we collect, use, share, and safeguard your data when you use UrPoster, a social media scheduling application ("Service"). By using the Service, you agree to the practices described in this policy.</p>

      <h2>1. Information We Collect</h2>
      <p>We collect the following types of information:</p>
      <ul>
        <li><strong>Account Information</strong>: When you create an account, we collect your username, email address, and a hashed version of your password.</li>
        <li><strong>User Content</strong>: We collect the media (e.g., images, videos) and captions you upload to schedule posts, as well as scheduling preferences.</li>
        <li><strong>Social Media Data</strong>: When you connect your social media accounts (e.g., TikTok, Instagram, Twitter, YouTube), we collect access tokens and basic profile information (e.g., username, profile picture) to enable posting on your behalf.</li>
        <li><strong>Usage Data</strong>: We collect information about how you use UrPoster, such as IP addresses, browser type, device information, and timestamps of your actions.</li>
        <li><strong>Cookies</strong>: We use cookies to manage sessions and improve your experience. A session cookie (`connect.sid`) is used to maintain your login state.</li>
      </ul>

      <h2>2. How We Use Your Information</h2>
      <p>We use your information to:</p>
      <ul>
        <li>Provide and improve the Service, such as scheduling posts and connecting to social media platforms.</li>
        <li>Authenticate your account and maintain session security.</li>
        <li>Communicate with you, including sending password reset emails or service updates.</li>
        <li>Analyze usage patterns to enhance functionality and user experience.</li>
        <li>Comply with legal obligations and platform policies.</li>
      </ul>

      <h2>3. How We Share Your Information</h2>
      <p>We do not sell your personal information. We may share your data as follows:</p>
      <ul>
        <li><strong>Third-Party Platforms</strong>: When you connect a social media account, we share access tokens with the platform to post on your behalf. These platforms (e.g., TikTok, Instagram, Twitter, YouTube) may have their own privacy policies.</li>
        <li><strong>Service Providers</strong>: We use third-party services like Cloudinary to store media files and Redis for session storage. These providers are bound by strict confidentiality agreements.</li>
        <li><strong>Legal Requirements</strong>: We may disclose your information if required by law or to protect our rights, safety, or property.</li>
      </ul>

      <h2>4. Data Storage and Security</h2>
      <ul>
        <li><strong>Storage</strong>: Your data is stored on secure servers hosted by Heroku, Cloudinary, and Redis. Access tokens are encrypted in our database.</li>
        <li><strong>Security</strong>: We use industry-standard measures, such as HTTPS and password hashing, to protect your data. However, no system is completely secure, and we cannot guarantee absolute security.</li>
        <li><strong>Retention</strong>: We retain your data only as long as necessary to provide the Service or comply with legal obligations. Account data is deleted within 30 days of account termination.</li>
      </ul>

      <h2>5. Your Rights and Choices</h2>
      <ul>
        <li><strong>Access and Update</strong>: You can access and update your account information by logging into UrPoster.</li>
        <li><strong>Delete Account</strong>: To delete your account, contact us at support@urposter.com. We will delete your data within 30 days.</li>
        <li><strong>Cookies</strong>: You can disable cookies in your browser, but this may affect the functionality of UrPoster.</li>
        <li><strong>Do Not Track</strong>: We do not respond to Do Not Track signals, as there is no standard for compliance.</li>
      </ul>

      <h2>6. Third-Party Links and Services</h2>
      <p>UrPoster integrates with third-party platforms like TikTok, Instagram, Twitter, and YouTube. These platforms have their own privacy policies, and we are not responsible for their practices. We encourage you to review their policies before connecting your accounts.</p>

      <h2>7. Children’s Privacy</h2>
      <p>UrPoster is not intended for users under 13 years old. We do not knowingly collect data from children under 13. If we learn that such data has been collected, we will delete it promptly.</p>

      <h2>8. International Users</h2>
      <p>UrPoster is hosted in the United States. If you access the Service from another country, your data may be transferred to the U.S., where data protection laws may differ. By using the Service, you consent to this transfer.</p>

      <h2>9. Changes to This Privacy Policy</h2>
      <p>We may update this Privacy Policy from time to time. We will notify you of significant changes by posting the updated policy on our website. Your continued use of the Service after such changes constitutes acceptance of the new policy.</p>

      <h2>10. Contact Us</h2>
      <p>If you have questions about this Privacy Policy or our data practices, please contact us at:</p>
      <ul>
        <li><strong>Email</strong>: support@urposter.com</li>
        <li><strong>Website</strong>: <a href="https://www.urposter.com">https://www.urposter.com</a></li>
      </ul>

      <p>Thank you for trusting UrPoster with your data!</p>
    </div>
  );
};

export default PrivacyPolicy;